import { showDeleteConfirmation } from '@modules/common';
import { switchMap, map } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { handleMessage, requestMessage } from '@business/messages';
import { TagAPI } from '@business/api/tag';
import { TagResponse, TagId } from '@business/entities/tag';
import { R } from '@core/utils/r';

export class TagBloc extends BaseBloc {
  private readonly tagsRepo = new Repository<TagResponse>({
    getItemId: tag => tag.id,
  });

  readonly tags$ = this.tagsRepo.items$.pipe(map(tags => R.sortBy(tags, t => t.name.toLowerCase())));

  onReset() {
    this.tagsRepo.reset();
  }

  fetchTags = () => {
    return TagAPI.fetchTags().pipe(this.tagsRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_tags_error') }));
  };

  createTag = (tag: Partial<TagResponse>) => {
    return TagAPI.createTag(tag).pipe(
      this.tagsRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_tag'),
      }),
    );
  };

  updateTag = (id: TagId, tag: Partial<TagResponse>) => {
    return TagAPI.updateTag(id, tag).pipe(
      this.tagsRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_tag'),
      }),
    );
  };

  deleteTag = (tagId: TagId) => {
    return showDeleteConfirmation('Delete Tag', `Do you really want to remove this tag? This will be removed from the all the organizations.`).pipe(
      switchMap(() => TagAPI.deleteTag(tagId)),
      this.tagsRepo.ops.removeOne(() => tagId),
      handleMessage({
        type: requestMessage('delete_tag'),
      }),
    );
  };
}
